<template>
  <el-dialog width="30%" :visible.sync="visible" title="请先完善信息才能使用债权转让协议线下签署" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '150px'">
      <el-form-item label="公司名称" prop="corporateName">
          <el-input v-model="dataForm.corporateName" placeholder="公司名称"></el-input>
      </el-form-item>

      <el-form-item label="法定代表人" prop="legalRepresentative">
          <el-input v-model="dataForm.legalRepresentative" placeholder="法定代表人"></el-input>
      </el-form-item>

      <el-form-item label="住所" prop="dwellingPlace">
          <el-input v-model="dataForm.dwellingPlace" placeholder="住所"></el-input>
      </el-form-item>

      <el-form-item label="债权受让方联系人" prop="creditorRight">
          <el-input v-model="dataForm.creditorRight" placeholder="债权受让方联系人"></el-input>
      </el-form-item>

      <el-form-item label="*债权受让方电话" prop="creditorTelephone">
          <el-input v-model="dataForm.creditorTelephone" placeholder="债权受让方电话"></el-input>
      </el-form-item>
    
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        corporateName: '',
        creditorRight: '',
        creditorTelephone: '',
        legalRepresentative: '',
        creditorTelephone: '',
      }
    }
  },
  computed: {
    dataRule () {
      return {
        corporateName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        legalRepresentative: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dwellingPlace: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creditorRight: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creditorTelephone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { required: true, pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的单位电话', trigger: 'change' }
        ],
      
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http['post']('/loan/transfer/signMessage', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.visible = false
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('callbackfn')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
